import { Form, Input } from "antd";
import { getConfigAppPartType } from "../../utils";
import { AppPartType } from "../../AppForm/types";
import { Styles } from "./styled";
import isNil from "lodash/isNil";
interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
  className?: string;
}

const Text = (props: IProps) => {
  const {
    item,
    isDisable,
    style,
    nameItem,
    preview,
    isTable,
    styleColor = {},
    className,
  } = props;
  const { isHiddenLabel, minChar, maxChar, labelText } =
    getConfigAppPartType(item);

  const form = Form.useFormInstance();
  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;
  return (
    <Styles style={style}>
      <div className="value_text_container">{isShowOnlyValue && value}</div>
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={[
          {
            required: item?.is_required_field,
            message: `必須項目です`,
          },
          {
            validator: (_: any, value: string) => {
              if (!value) return Promise.resolve();
              const length = value.length;
              if (!isNil(minChar) && !isNil(maxChar)) {
                const length = value
                  .replaceAll(",", "")
                  .replace(".", "").length;
                if (length > maxChar || length < minChar)
                  return Promise.reject(
                    `文字の数は${minChar}文字から${maxChar}文字です。`,
                  );
              } else if (!isNil(minChar)) {
                if (length < minChar)
                  return Promise.reject(`文字の数は${minChar}文字以上です。`);
              } else if (!isNil(maxChar)) {
                if (length > maxChar)
                  return Promise.reject(`文字の数は${maxChar}文字以下です。`);
              }
              return Promise.resolve();
            },
          },
        ]}
        validateTrigger="onBlur"
        className={className}
      >
        <Input style={styleColor} onPressEnter={(e) => e.preventDefault()} />
      </Form.Item>
    </Styles>
  );
};
export default Text;
